/** @format */
import React from 'react';
import PropTypes from 'prop-types';

const ConditionalButton = props => {
    if (!props.enabled) {
        return props.children[1];
    }

    return props.children[0];
};

ConditionalButton.propTypes = {
    enabled: PropTypes.bool.isRequired,
    children: PropTypes.arrayOf(PropTypes.element).isRequired
};

export default ConditionalButton;
